module.exports = __webpack_public_path__ + "static/media/portfolio 1.0f3828d3.JPG";